import isLength from 'validator/es/lib/isLength';
import Attach from '../../../../_00_elements/tools/attach';
import TwigFormValidator from '../../../../_00_elements/tools/twig-form/validator';
import translation from '../../../../_00_elements/translation';
import Logger from '../../../../_00_elements/tools/logger/logger';
import { URL_REGISTER_RESEND_EMAIL, URL_REGISTER } from '../../../../_00_elements/tools/routes/routes';
import { hideSubmitLoader } from '../../../../_01_atoms/spinner';
import resendInitPasswordEmail from '../../../../_00_elements/resend-init-password-email';
import Modal from '../../../../_01_atoms/components/Modal.vue';
import requests from '../../../../_00_elements/tools/requests-mixin';
import eventBus from '../../../../_00_elements/tools/event-bus';

/**
 * Register Modal Component
 * This component use the modal component as a child.
 * It displays register form.
 */
export default {
  template: '#user-modal-component',
  components: {
    Modal,
  },
  props: [ 'isOpened', 'redirectUrl' ],
  mixins: [ translation, requests ],
  delimiters: [ '${', '}' ],
  data() {
    return {
      htmlBody: '',
      modalTitle: '',
      dataTrad: {},
      dataForm: {},
    };
  },
  methods: {
    switchTo(newModalName, args) {
      this.htmlBody = '';
      this.modalTitle = '';
      eventBus.dispatchEvent(new CustomEvent('switch-from-to-modal', {
        detail: {
          oldModalName: 'Register',
          newModalName,
          args,
        },
      }));
    },
    close() {
      this.saveInputsData();
      this.htmlBody = '';
      this.modalTitle = '';
      this.$emit('close');
    },
    /**
     * on close modal, save input data
     * in case of miss click by user
     */
    saveInputsData() {
      if (!document.getElementById('app_user_registration_save')) {
        return;
      }
      const inputs = [
        'app_user_registration_email',
        'app_user_registration_firstname',
        'app_user_registration_lastname',
      ];
      for (let i = 0, l = inputs.length; i < l; i++) {
        const key = inputs[i];
        this.dataForm[key] = document.getElementById(key).value;
      }
    },
    /**
     * on form load, display pre set data
     */
    setInputData() {
      this.$nextTick(() => {
        for (const key in this.dataForm) { // eslint-disable-line guard-for-in, no-restricted-syntax, max-len
          document.getElementById(key).value = this.dataForm[key];
        }
        this.dataForm = {};
      });
    },
    /**
     * initForm
     * @param selector
     * @description validate form using specific rules
     */
    initForm() {
      this.$nextTick(() => {
        const validator = new TwigFormValidator({
          formSelector: '.user_registration_register',
          rules: {
            'app_user_registration[email]': 'email',
            'app_user_registration[firstname]': 'noNumbers',
            'app_user_registration[lastname]': 'noNumbers',
            'app_user_registration[plainPassword][first]': (value) => isLength(value, { min: 6 }),
            'app_user_registration[plainPassword][second]': (value) => value === document.getElementById('app_user_registration_plainPassword_first').value,
          },
          messages: {
            'app_user_registration[plainPassword][first]': 'passwordTooShort',
            'app_user_registration[plainPassword][second]': 'passwordNotTheSame',
          },
          onSuccess: (event) => {
            Attach.asyncSubmit(event)
              .then((result) => {
                this.htmlBody = result.data;
                this.initForm();
                hideSubmitLoader('#app_user_registration_save');

                this.$nextTick(() => {
                  if (document.getElementById('check-email-continue')) {
                    this.modalTitle = this.trans('form.check_email.modal_title');
                    Attach.onClickEvent('check-email-continue', () => {
                      this.htmlBody = '';
                      this.close();
                    });
                    resendInitPasswordEmail(
                      '.check-email .registration-email-resend a',
                      URL_REGISTER_RESEND_EMAIL,
                    );
                  } else {
                    if (document.getElementById('open_login_modal_with_email')) {
                      Attach.onClickEvent('open_login_modal_with_email', () => {
                        const email = document.getElementById('app_user_registration_form_email').value;
                        this.switchTo('Login', [ email, this.redirectUrl ]);
                      });
                    }

                    this.attachOnClickEventToOpenLoginModal();
                  }
                });
              });
          },
        });
        validator.init();
      });
    },
    attachOnClickEventToOpenLoginModal() {
      Attach.onClickEvent('switch-connection-from-register-button', () => {
        this.switchTo('Login', '', this.redirectUrl);
      });
      if (document.getElementById('switch-connection-from-error-button')) {
        Attach.onClickEvent('switch-connection-from-error-button', () => {
          this.switchTo('Login', '', this.redirectUrl);
        });
      }
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal || (newVal && this.htmlBody !== '')) {
        return;
      }

      this.modalTitle = this.trans('form.register.modal_title');

      const redirectUrlSlug = this.redirectUrl ? `?_redirectUrl=${encodeURIComponent(this.redirectUrl)}` : '';
      const FORMATTED_URL_REGISTER = URL_REGISTER + redirectUrlSlug;

      this.get(FORMATTED_URL_REGISTER).then((responseRegister) => {
        this.htmlBody = responseRegister.data;
        this.setInputData();
        this.initForm();
        this.attachOnClickEventToOpenLoginModal();
      }).catch((error) => {
        Logger.debug(error);
      });
    },
  },
};
